import { useQuery } from '@tanstack/react-query';

import { getIsInsolvent } from '../api/insolvent';

/**
 * Hook to fetch if current medical center user is insolvent
 * @param {import("@tanstack/react-query").UseQueryOptions?} options
 */
export function useIsInsolvent(options = {}) {
  return useQuery({
    queryKey: ['isInsolvent'],
    queryFn: () => getIsInsolvent(),
    ...options,
  });
}
